module.exports = __webpack_public_path__ + "static/media/journey-hardy.3ae88d2e.svg";